"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentProvider = exports.getOverridesFromSearch = exports.EXPERIMENT_IDS = exports.useExperiments = exports.ExperimentContext = void 0;
const api_1 = require("core/api");
const React = __importStar(require("react"));
const useRequest_1 = require("./useRequest");
exports.ExperimentContext = React.createContext({});
const useExperiments = () => {
    const context = React.useContext(exports.ExperimentContext);
    if (!context) {
        throw new Error('useExperiments must be used within a ExperimentProvider');
    }
    return context;
};
exports.useExperiments = useExperiments;
exports.EXPERIMENT_IDS = {
    AGE_GATING: 'ageGating',
    INVITE_OFFERS: 'inviteOffers',
    NEW_PRICING_PAGE: 'newPricingPage',
    INVITE_OFFERS_NEW: 'inviteOffersNew',
};
const getOverridesFromSearch = (search) => {
    if (search) {
        const urlParams = new URLSearchParams(search);
        const overrides = Object.values(exports.EXPERIMENT_IDS).reduce((acc, experimentId) => {
            const override = urlParams.get(experimentId);
            if (typeof override === 'string') {
                acc[experimentId] = { hasAccess: override === 'true', isEnabled: true };
            }
            return acc;
        }, {});
        return overrides;
    }
    return {};
};
exports.getOverridesFromSearch = getOverridesFromSearch;
const ExperimentProvider = ({ children }) => {
    const [value, setValue] = React.useState({});
    const { makeRequest } = (0, useRequest_1.useRequest)();
    const getExperiments = async () => {
        // override experiment values with url params
        const urlParamOverrides = (0, exports.getOverridesFromSearch)(window.location.search);
        // get experiments from the server
        const { data } = await makeRequest(() => api_1.RolloutService.getExperiments());
        setValue({ ...(data || {}), ...urlParamOverrides });
    };
    React.useEffect(() => {
        getExperiments();
    }, []);
    return React.createElement(exports.ExperimentContext.Provider, { value: value }, children);
};
exports.ExperimentProvider = ExperimentProvider;
